module.exports = __webpack_public_path__ + "img/banner2.18eb7420.png";